export default function CTASection() {
  return (
    <section className="grid grid-cols-1 lg:grid-cols-2 min-h-[520px] md:min-h-[580px]">
      {/* Left - image */}
      <div className="relative overflow-hidden bg-foreground-900">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20fashion%20editorial%20scene%20with%20model%20silhouette%20wearing%20oversized%20coat%20surrounded%20by%20floating%20sneakers%20handbags%20and%20accessories%20against%20deep%20moody%20charcoal%20background%20with%20strong%20directional%20spotlight%20creating%20bold%20shadows%20high-end%20magazine%20aesthetic%20luxury%20campaign%20photography&width=900&height=1200&seq=cta-split-2026-v3&orientation=portrait"
          alt="Superbuy Sheet product collection"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 to-transparent"></div>
        <div className="absolute bottom-10 left-10">
          <span className="text-white/50 text-xs uppercase tracking-widest">superbuyspread.pics</span>
          <p className="mt-2 font-heading text-3xl md:text-4xl font-bold text-white leading-tight">
            Discover More.{' '}
            <span className="text-accent-300">Shop Smarter.</span>
          </p>
        </div>
      </div>

      {/* Right - content */}
      <div className="flex items-center justify-center bg-background-50 px-8 md:px-16 py-16">
        <div className="max-w-md text-center">
          <span className="inline-block px-4 py-1.5 text-xs font-semibold text-foreground-500 uppercase tracking-wider rounded-full border border-background-300/60">
            Ready to Explore
          </span>
          <h2 className="mt-5 font-heading text-3xl md:text-4xl font-bold text-foreground-900 tracking-tight leading-tight">
            Your Next Great Find{' '}
            <span className="text-accent-600">Is Waiting</span>
          </h2>
          <p className="mt-5 text-foreground-500 text-base leading-relaxed">
            Jump into the full Superbuy Sheet platform and start exploring thousands of products across every category. Organized, updated, and ready for you to discover.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 font-semibold text-sm rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              superbuy sheet
              <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 border border-foreground-300 text-foreground-700 font-medium text-sm rounded-full hover:bg-foreground-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              buy it now
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}